import { render, staticRenderFns } from "./dialog_record.vue?vue&type=template&id=6da743d3&"
import script from "./dialog_record.vue?vue&type=script&lang=js&"
export * from "./dialog_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports